import axios from 'axios'
import { Message } from 'element-ui'
import store from "../store"
import router from '../router'
import qs from 'qs'

export const tips = (message = '请求错误，请重试', type = 'error', onClose = () => { }) => {
    Message ({
        message,
        type,
        duration: 3 * 1000,
        onClose
    })
}
const whiteList = [/\.json$/, /^\/users/, /^\/op\/mingeWorkbook\/download/]

const checkInWhiteList = (url) => {
    let isIn = false
    if (url) {
        whiteList.forEach(wl => {
            if (typeof wl === 'string') {
                if (wl === url) {
                    isIn = true
                    return
                }
            } else {
                if (wl.test(url)) {
                    isIn = true
                    return
                }
            }
        })
    }
    return isIn
}

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 50 * 1000
})

let redirectingToLogin = false

const handleUnauthorized = async (response, config = response.config) => {
    const token = store.state.user.token
    const requestToken = config && config._sessionToken
    // 已重新登录时，旧请求的 401 不应清除新会话。
    if (token && requestToken !== token) return
    if (redirectingToLogin) return
    if (!token && router.currentRoute.path === '/login') {
        // 登录失败仍显示接口提示；已失效会话的并发响应不再重复提示。
        if (!requestToken) {
            const data = response.data || {}
            tips(data.message || data.msg || 'token已失效，请重新登录')
        }
        return
    }

    redirectingToLogin = true
    try {
        tips('token已失效，请重新登录')
        await store.dispatch('user/clearCache')
        if (router.currentRoute.path !== '/login') {
            await router.replace({ path: '/login' })
        }
    } finally {
        redirectingToLogin = false
    }
}

service.interceptors.request.use(
    config => {
        const { token } = store.state.user
        config._sessionToken = token || ''
        if (token) {
            config.headers.Authorization = token
        }
        return config
    },
    error => {
        console.log('interceptors.request.use====', error)
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    async response => {
        const isInWhiteList = checkInWhiteList(response.config && response.config.url)
        let res = response.data
        // 鉴权失败优先于接口白名单和业务错误消息处理。
        if (Number(response.status) === 401 || (res && Number(res.code) === 401)) {
            await handleUnauthorized(response)
            return Promise.reject(res)
        }
        // http状态码为20x的都是成功
        if (response.status == 204) {
            res = res || { code: 200, data: 'ok' }
        }
        if (!isInWhiteList && res && res.code && ![200, 10000, 101, 102].includes(res.code)) {
            if (![100].includes(res.code)) tips(res.message || res.msg)
            return Promise.reject(res)
        } else {
            return res
        }
    },
    async error => {
        const response = error.response
        const data = response && response.data
        if (response && (Number(response.status) === 401 || (data && Number(data.code) === 401))) {
            await handleUnauthorized(response, response.config || error.config)
        } else if (data && (data.message || data.msg)) {
            tips(data.message || data.msg)
        } else if (response && Number(response.status) === 403) {
            tips('不允许访问')
        } else if (!response && !axios.isCancel(error)) {
            tips(error.message || '请求错误，请重试')
        }
        return Promise.reject(error)
    }
)

export default {
    get (config) {
        return service(Object.assign(config, {
            method: 'get'
        }))
    },

    post (config) {
        return service(Object.assign(config, {
            method: 'post'
        }))
    },

    postForm (config) {
        config.data = qs.stringify(config.data)
        return service(Object.assign(config, {
            method: 'post',
            headers: { 'content-type': 'application/x-www-form-urlencoded' }
        }))
    },

    postFormData (config) {
        const formData = new FormData()
        let data = config.data || {}
        Object.keys(data).forEach(key => {
            if (data[key]) {
                if (key === 'file' && Array.isArray(data.file)) {
                    data.file.forEach(f => formData.append('file', f))
                } else {
                    formData.append(key, data[key])
                }
            }
        })
        config.data = formData
        return service(Object.assign(config, {
            method: 'post',
            headers: { 'content-type': 'multipart/form-data' }
        }))
    },

    put (config) {
        return service(Object.assign(config, {
            method: 'put'
        }))
    },

    delete (config) {
        return service(Object.assign(config, {
            method: 'delete'
        }))
    }
}
